import { useState } from "react";
import { C } from "../data/content";

export const Accordion = ({ items, testPrefix, defaultOpen = 0 }) => {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <div className="border-t border-white/[0.08]">
      {items.map((it, i) => (
        <div key={i} className={`acc-item border-b border-white/[0.08] ${open === i ? "open" : ""}`} data-testid={`${testPrefix}-item-${i + 1}`}>
          <button className="w-full flex items-center gap-6 py-6 text-left cta"
            onClick={() => setOpen(open === i ? -1 : i)} data-testid={`${testPrefix}-toggle-${i + 1}`}>
            <span className="mono text-[13px] text-[var(--accent)]">{String(i + 1).padStart(2, "0")}</span>
            <span className="font-black uppercase text-[15px] md:text-[17px] tracking-wide flex-1">{it.title}</span>
            <span className="acc-icon text-[var(--accent)] text-2xl font-light leading-none">+</span>
          </button>
          <div className="acc-body">
            <p className="text-[14px] text-white/50 leading-relaxed pb-7 pl-12 max-w-[640px]">{it.body}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export const Curriculum = () => (
  <section className="py-28 px-6 lg:px-12" data-testid="curriculum-section">
    <div className="max-w-[1100px] mx-auto">
      <div className="flex flex-wrap items-end justify-between gap-4 mb-12">
        <div>
          <p className="mono text-[11px] tracking-[0.25em] text-[var(--accent)] mb-6">[004] — THE CURRICULUM</p>
          <h2 className="h1-display text-[clamp(28px,3.4vw,48px)]">GET A SNEAK PEEK<br />INTO THE WEBINAR</h2>
        </div>
        <p className="mono text-[11px] text-white/40">{C.moduleCount} MODULES · {C.duration} TOTAL</p>
      </div>
      <Accordion items={C.modules} testPrefix="module" />
    </div>
  </section>
);
